import { render } from "react-dom";
import "./styles/index.css";
import App from "./App";
import React from "react";

const root = document.getElementById("root");
render(<App />, root);


